import {BaseApi} from "@/core/api/base.api";
import {roomCallMixerLayout} from "@/core/api/room.call.mixer.layout";
import {RoomCall} from "@/core/api/room.call.api";
import {roomCallMixingService} from "@/core/service/roomCallMixerService";
import {Room} from "@/core/api/room.api";
import {Role} from "@/core/api/util.api";
import {roomGroupApi} from "@/core/api/room.group.api";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import {roomCallService} from "@/core/service/room.call.service";
import _ from "lodash";
import {RoomCallLog} from "@/core/api/room.call.log.api";
import {roomEventApi} from "@/core/api/room.event.api";
import {RoomUser} from "@/core/api/room.user.api";
import {RoomCallStream} from "@/core/api/room.call.stream.api";

const CALL_TYPE = 'mixing';
export class RoomCallMixerApi extends BaseApi {
    #mixer;
    #callType;

    constructor(options={apiName: 'Mixer', callType: CALL_TYPE}) {
        super();
        this.init(options);
    }

    init(options={apiName: 'Mixer', callType: CALL_TYPE}) {
        if(RoomCall[options.apiName]) return;

        RoomCall[options.apiName] = this;
        this.#callType = options.callType;

        // this._Events = Object.assign(this._Events || {}, _Events());
        this._Events = _Events();
        RoomCall.addCallTypeEventListener(options.callType, this._Events, this);

        if(this.isCurrentClass(RoomCallMixerApi)){
            Room.addEventListeners(this._CoreEvents, this);
        }
    }

    destroy() {
        const mixer = this.getMixer();
        if(!mixer) return;

        console.log('grm mixer api destroy');
        mixer.conn?.close();
        delete mixer.conn;
    }

    getCallType() {
        return this.#callType;
    }

    isMixing(current) {
        let roomCall = Room.getRoomData().roomCall
        const callType = !current ? CALL_TYPE : this.getCallType() || CALL_TYPE;
        return roomCall.callType === callType
            // || roomCall.callType === 'mixer-sfu'
    }

    getMixer() {
        return this.#mixer
    }

    setMixer(mixer) {
        this.#mixer = mixer;
        return mixer;
    }

    createMixerWebRTCConnection(mixer, options={}) {
        // let roomOptions = Room.getRoomData().roomOptions;
        let config = {};

        let conn = new GrmWebRTC(options);
        conn.createPeerConnection(config, options);

        conn
            .addEventListener('negotiationneeded', async e => {
                console.debug('# peer.%s : mixer', e.type);
                conn._req_offer_work = conn._req_offer_work || _.debounce(() => {
                    this.requestOffer();
                }, 200);
                conn._req_offer_work();
            })
            .addEventListener('addstream', e => {
                let stream = e.stream;

                console.log('%s mixer : user[%s/%s], id[%s], v[%d], a[%d]',
                    e.type
                    , mixer.userId, mixer.nickname
                    , stream.id
                    , stream.getVideoTracks().length
                    , stream.getAudioTracks().length
                );

                let streamIdMap = this.#mixer.setting.streamIdMap;
                let eventType = 'room_call_addstream_mixer_primary';
                switch(stream.id){
                    case streamIdMap.videoStreamId: {
                        let secondStreamTracks = stream.getTracks().filter(track => {
                            let chk = track.id === streamIdMap.secondVideoStreamVideoTrackId
                                || track.id === streamIdMap.secondVideoStreamAudioTrackId
                                || track.id.includes('_secondary_');
                            if (chk) {
                                stream.removeTrack(track);
                            }
                            return chk;
                        });
                        if(secondStreamTracks.length > 0){
                            conn.secondStream = conn.secondStream || new MediaStream();
                            secondStreamTracks.forEach(s => conn.secondStream.addTrack(s));

                            Room.emit('room_call_addstream_mixer_second', {stream: conn.secondStream});
                            // return;
                        }
                        if(stream.getAudioTracks().length > 0){
                            Room.emit('room_call_addAudioTrack', {userId: 'grm-mixer', track: stream.getAudioTracks()[0]});
                        }
                        break;
                    }
                    case streamIdMap.secondVideoStreamId:
                        eventType = 'room_call_addstream_mixer_second';
                        break;
                    default:
                        break;
                }

                conn.stream = stream;
                Room.emit(eventType, {stream});
            })
            .addEventListener('removestream', e => {
                let stream = e.stream;
            })
            .addEventListener('icecandidate', async e => {
                if(!e.candidate){
                    return;
                }
                await roomCallService.sendIcecandidate({
                    callType: 'mixing',
                    toUserId: mixer.userId,
                    iceCandidate: e.candidate
                });
            })
            .addEventListener('iceconnectionstatechange', e => {
                let state = e.target.iceConnectionState;
                switch(state){
                    case 'connected': {
                        console.log('pc ice statechange : %s,', state, mixer.userId, mixer.nickname);

                        delete this._mixer_retry;

                        Room.emit('room_call_mixerConnected');

                        this.conectionStats({start: true});
                        break;
                    }
                    case 'disconnected':
                    case 'closed': {
                        if(this.isMixing()){
                            console.error('pc ice statechange : %s,', state, mixer.userId, mixer.nickname, e);
                        }
                        Room.emit('room_call_mixerDisconnected');
                        Room.emit('room_call_userConnectionDisconnected', {userId: mixer.userId});

                        this.conectionStats({start: false});

                        // reconn
                        (() => {
                            if(!this.isMixing(true)){
                                return;
                            }
                            this._mixer_retry = {
                                disconnectTime: new Date(),
                                retryCnt: 0,
                                run: () => {
                                    clearTimeout(this._mixer_retry.timer);

                                    if(Room.isLeaved()){
                                        return;
                                    }
                                    if(!this.isMixing(true)){
                                        return;
                                    }

                                    this._mixer_retry.timer = setTimeout(() => {
                                        if(Room.isLeaved()){
                                            return;
                                        }

                                        const mixer = this.getMixer();
                                        if(mixer?.conn?.isConnected()){
                                            return;
                                        }

                                        if(this._mixer_retry.retryCnt > 50){
                                            console.warn('mixer reconnect stopped : retryCnt[%d], disconnectedTime[%s]',
                                                this._mixer_retry.retryCnt,
                                                this._mixer_retry.disconnectTime
                                            );
                                            return;
                                        }

                                        this._mixer_retry.retryCnt++;
                                        console.warn('mixer reconnect : retryCnt[%d], disconnectedTime[%s]',
                                            this._mixer_retry.retryCnt,
                                            this._mixer_retry.disconnectTime
                                        );

                                        try{
                                            RoomCall._enterCall();
                                        }catch(e){
                                            console.error(e);
                                        }
                                        this._mixer_retry.run();
                                    }, 3000);
                                }
                            };
                            this._mixer_retry.run();
                        })()
                        break;
                    }
                    case 'failed': {
                        Room.emit('room_call_mixerConnectFailed');
                        console.error('pc ice statechange : %s,', state, mixer.userId, mixer.nickname, e);

                        this.conectionStats({start: false});
                        break;
                    }
                    default:
                        console.log('pc ice statechange : %s,', state, mixer.userId, mixer.nickname);
                        break;
                }
            })
            .addEventListener('signalingstatechange', async e => {
                let state = e.target.signalingState;
                switch(state){
                    case 'stable':
                        await roomCallService.sendSignalStable({
                            callType: 'mixing',
                            toUserId: mixer.userId
                        });
                        break;
                    case 'closed':
                        break;
                }
            })
            .addEventListener('datachannel', e => {
                const dataChannel = e.channel;
                let label = dataChannel.label;

                conn.defaultDataChannel = dataChannel;
                dataChannel.onerror = e => {
                    console.log('#[grm-webrtc] dc[%s] error :', label, mixer.userId, e);
                };
                dataChannel.onopen = e => {
                    console.log('#[grm-webrtc] dc[%s] open :', label, mixer.userId);

                };
                dataChannel.onclose = e =>{
                    console.log('#[grm-webrtc] dc[%s] close : %s, bufferedAmount[%d], bufferedAmountLowThreshold[%d]',
                        label,
                        mixer.userId,
                        dataChannel.bufferedAmount, dataChannel.bufferedAmountLowThreshold,
                        e);
                };

                let buffer;
                dataChannel.onmessage = event => {
                    // uint 16 array
                    let msg = new DataView(event.data);
                    let cmd = msg.getUint16(0);

                    switch (cmd) {
                        case 100: {
                            // mic volume
                            let roomData = Room.getRoomData();
                            let mixingLayoutInfo = roomData.roomCall.mixingLayoutInfo;
                            if (!mixingLayoutInfo) {
                                return;
                            }
                            let channelSeqList = mixingLayoutInfo.channelSeqList;

                            let isGroupMode = Room.isRoomGroupMode()
                            let me = roomData.me;
                            if(isGroupMode){
                                if(
                                    mixingLayoutInfo.roomGroupDataMap
                                    && mixingLayoutInfo.roomGroupDataMap[me.roomGroupId]
                                    && mixingLayoutInfo.roomGroupDataMap[me.roomGroupId].channelSeqList
                                ) {
                                    channelSeqList = mixingLayoutInfo.roomGroupDataMap[me.roomGroupId].channelSeqList;
                                }
                            }

                            let size = msg.getUint16(2);
                            for (let i = 4; i < 4 + (size * 2); i += 2) {
                                let channelId = msg.getUint8(i);
                                let volume = msg.getUint8(i + 1);

                                if (volume < 1) continue;

                                let userId = channelSeqList[channelId];
                                if (!userId) {
                                    continue;
                                }

                                RoomCall.setUserVolumeData({userId, volume});
                            }
                            break;
                        }
                        case 500: {
                            try {
                                let len = msg.getUint32(4);
                                let payload = String.fromCharCode.apply(null, new Uint8Array(event.data.slice(8, 8 + len)));

                                if (!buffer) buffer = [];
                                buffer.push(payload);
                            } catch (e) {
                                console.error(e);
                            } finally {
                                (() => {
                                    if (msg.getUint16(2) !== 1) { // end msg
                                        return;
                                    }

                                    let len = buffer.length;
                                    let event = JSON.parse(buffer.join(''));
                                    buffer = null;

                                    console.log('#[grm-webrtc] dc[%s] mixer msg : len[%d]', label, len, event);

                                    switch (event.api) {
                                        case '/mixer/room/changeLayout':
                                            roomEventApi.trigger('room_call_changeMixingLayout', Object.assign(event.data, {
                                                success: true
                                            }));
                                            // THIS._Events.room_call_changeMixingLayout.call(THIS, {
                                            //     type: 'room_call_changeMixingLayout',
                                            //     data: Object.assign(event.data, {
                                            //         success: true
                                            //     })
                                            // });
                                            break;
                                        case '/mixer/room/user/offer':
                                            roomEventApi.trigger({
                                                type: 'room_call_offer',
                                                userId: mixer.userId,
                                                data: event.data
                                            });
                                            // THIS._Events.room_call_offer.call(THIS, {
                                            //     type: 'room_call_offer',
                                            //     userId: mixer.userId,
                                            //     data: event.data
                                            // });
                                            break;
                                    }
                                })();
                            }
                            break;
                        }
                    }
                }
            });
        return conn;
    }

    requestOffer(reason) {
        roomCallService.requestOffer({toUserId: this.#mixer.userId, reason});
    }

    getStream() {
        return this.#mixer?.conn?.stream;
    }
    async getSecondStream() {
        const stream = this.#mixer?.conn?.secondStream;
        if(!stream){
            return null;
        }
        const track = stream.getVideoTracks()[0];
        if(!track){
            return null;
        }
        if(!track.muted){
            return stream;
        }

        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => {
                resolve(null);
            }, 2000);
            function ok(){
                clearTimeout(timer);
                resolve(stream);
            }
            track.addEventListener('unmute', ok, {once: true});
        });
    }

    async changeMixingVideoChannelByUserId(data) {
        await roomCallMixingService.changeMixingVideoChannelByUserId(data)
    }

    async changeMixingLayoutType({ roomGroupId, layoutType }) {
        if(!layoutType){
            return;
        }

        this._changeMixingLayoutType_work = this._changeMixingLayoutType_work || _.throttle(async ({ roomGroupId, layoutType }) => {
            await roomCallMixingService.changeMixingLayoutType({ roomGroupId, layoutType });
        }, 100, {
            leading: true
        });
        this._changeMixingLayoutType_work({ roomGroupId, layoutType });
    }

    toggleUserMixingVideoByUserId(data) {
        return roomCallMixingService.toggleUserMixingVideoByUserId(data);
    }

    getMixingLayoutRect(options) {
        /*
			{
				video: [videoElement],
				videoWidth,
				videoHeight,
				view: [htmlElement],
				viewWidth,
				viewHeight,
				useSecondStream: [boolean],
				data: [mixingLayoutInfo]
			}
			* */
        let data = options.data || Object.assign({}, Room.getRoomData().roomCall?.mixingLayoutInfo)
            ||
            { // 가 데이터
                "broadcastWaitingroomMode": false,
                "channelSeq": "8",
                "excludeUserIds": [],
                "hiddenUsers": "",
                "includeUserIds": [],
                "interviewMode": false,
                "layoutMode": "mixingmodeauto",
                "layoutType": "ml_18_00",
                "pageInfo": {
                    "curPageIndex": 0,
                    "totalPageCount": 1
                },
                "roomId": "a8e12f2b95394351837a2a3687d8bb79",
                "screenBlockUsers": [],
                "userIdSeq": "13ddcadf1",
                "waitingRoomMode": false,
                "waitingRoomUserIds": [],
                "success": true,
                "channelSeqList": [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "13ddcadf1"
                ],
                "userIdSeqList": [
                    "13ddcadf1"
                ],
                "channelUserMap": {}
            };

        if(!data){
            return;
        }
        if(options.useSecondStream && data.secondStream){
            // let secondStream = Room.getMixerUserSecondaryVideo();
            // if(secondStream && secondStream.getVideoTracks().length > 0 && !secondStream.getVideoTracks()[0].muted){
            data = data.secondStream;
            // }
        }

        const {videoWidth, videoHeight, viewWidth, viewHeight, layoutMarginTop} = options;

        // result
        let result = {};

        if(layoutMarginTop != undefined) {
            Object.assign(data, {layoutMarginTop})
        }
        // begin : base
        result.base = this.getMixingLayoutRectList(
            videoWidth, videoHeight, viewWidth, viewHeight,
            data
        ); // end : base

        // begin : room group mode
        (() => {
            if(!Room.isRoomGroupMode() || !data.roomGroupInMain || !data.roomGroupInMain.userIdSeqList){
                return;
            }
            result.group = {
                rectList: []
            };

            let ratioHeight = videoHeight / (videoWidth / viewWidth);
            ratioHeight = Math.min(ratioHeight, viewHeight);
            let margin = (viewHeight - ratioHeight) / 2
            let topVideoHeight = roomGroupApi.noContentGroupMode() ? result.base.height : 0;

            let rectResult = options.rectData || roomCallMixerLayout.getMixingLayoutRectList(
                data.layoutType,
                videoWidth, videoHeight,
                viewWidth, viewHeight
            );
            // let groupMain = rectResult.groupMain;

            let subGroupLayerWidth = rectResult.width;
            let subGroupLayerHeight = viewHeight - (margin*2) - topVideoHeight;

            let subGroupVideoWidth = videoWidth;
            let subGroupVideoHeight = videoWidth / (subGroupLayerWidth / subGroupLayerHeight);

            // group main layer
            Object.assign(result.group, {
                left: rectResult.left,
                top : margin + topVideoHeight,
                width: subGroupLayerWidth,
                height: subGroupLayerHeight,
            });

            let myRoomGroupData = roomGroupApi.isInRoomGroup() && data.roomGroupDataMap && data.roomGroupDataMap[Room.getRoomData().me.roomGroupId];
            if(myRoomGroupData){
                let rData = Object.assign({
                    videoWidth: subGroupVideoWidth, //1280,
                    videoHeight: subGroupVideoHeight, //648,
                    viewWidth: subGroupLayerWidth,
                    viewHeight: subGroupLayerHeight
                }, {data : myRoomGroupData});

                result.group.myGroup = this.getMixingLayoutRect(rData);
                Object.assign(result.group.myGroup, {roomGroupId : Room.getRoomData().me.roomGroupId})
                return;
            }

            // room groups layer
            let roomGroupWrapperRectList = roomCallMixerLayout.getMixingLayoutRectList(
                data.roomGroupInMain.layoutType,
                subGroupVideoWidth, subGroupVideoHeight,
                subGroupLayerWidth, subGroupLayerHeight
            );
            if(!roomGroupWrapperRectList) return;

            for(let i=0; i<roomGroupWrapperRectList.length; i++) {
                let roomGroupId = data.roomGroupInMain.userIdSeqList[i];
                let roomGroupWrapperRect = roomGroupWrapperRectList[i];
                let roomGroupData = data.roomGroupDataMap && data.roomGroupDataMap[roomGroupId];
                if(!roomGroupData){
                    continue;
                }

                let roomGroupVideoRect = this.getMixingLayoutRect({
                    data: roomGroupData,
                    // videoWidth: roomGroupWrapperRect.width, videoHeight: roomGroupWrapperRect.height,
                    videoWidth: subGroupVideoWidth, videoHeight: subGroupVideoHeight,
                    viewWidth: roomGroupWrapperRect.width, viewHeight: roomGroupWrapperRect.height
                });

                roomGroupWrapperRect = Object.assign({roomGroupId}, roomGroupWrapperRect, {
                    videoRectList: roomGroupVideoRect.base
                });

                result.group.rectList.push(roomGroupWrapperRect);
            }
        })(); // end : room group mode

        return result;
    }

    getMixingLayoutRectList(video_width, video_height, view_width, view_height, mixingLayoutInfo) {
        mixingLayoutInfo = mixingLayoutInfo || Room.getRoomData().roomCall.mixingLayoutInfo;
        if(!mixingLayoutInfo){
            return [];
        }

        let layoutType = mixingLayoutInfo.layoutType;

        let rectList = roomCallMixerLayout.getMixingLayoutRectList(layoutType, video_width, video_height, view_width, view_height, mixingLayoutInfo.layoutMarginTop);

        let seqList = mixingLayoutInfo.channelSeqList;

        if(!rectList) {
            return null;
        }
        for(let i=0, len=Math.min(rectList.length, seqList.length); i<len; i++){
            if(!seqList[i]) continue;
            let rect = rectList[i];
            rect.userId = seqList[i];

            let id = ['pip', 'vip', 'vad', 'clone', 'screenshare'].map(k => rect[k] ? k : '').join('_');
            rect.id = `${rect.userId}_${id}`;
        }

        rectList.pageInfo = mixingLayoutInfo.pageInfo;
        return rectList;
    }

    _setMixingLayoutInfoChannelSeqList(mixingLayoutInfo){
        try{
            let channelSeqList = mixingLayoutInfo.channelSeqList;
            if(channelSeqList){
                return;
            }

            let channelSeqArray, userIdSeqArray, list;
            let userIdSeqList = [];
            if(!mixingLayoutInfo.channelSeq){
                mixingLayoutInfo.channelSeqList = [];
                channelSeqArray = [];
                userIdSeqArray = [];
                list = [];
            }else{
                channelSeqArray = mixingLayoutInfo.channelSeq.split(','),
                userIdSeqArray = mixingLayoutInfo.userIdSeq.split(','),
                list = new Array(channelSeqArray.length);
            }

            let channelUserMap = new Map();

            for(let i=0, len=channelSeqArray.length; i<len; i++){
                let userId = userIdSeqArray[i];
                let type, screenshare, vip, vad, videoState, name;

                let str = userId;
                while(str.indexOf('@@(') === 0){
                    let tIdx = str.indexOf(')', 3),
                        temp = str.substring(3, tIdx);
                    str = str.substring(tIdx+1);

                    switch(temp){
                        case 'screen':
                            screenshare = true;
                            userId = userId.substring(tIdx+1);
                            break;
                        case 'vip':
                            vip = true;
                            userId = userId.substring(tIdx+1);
                            break;
                        case 'vad':
                            vad = true;
                            userId = userId.substring(tIdx+1);
                            break;
                        case 'clone':
                            userId = userId.substring(tIdx+1);
                            break;
                        case 'videolow':
                        case 'videooff':
                            videoState = temp;
                            userId = userId.substring(tIdx+1);
                            break;
                        default:
                            type = temp;
                            userId = userId.substring(tIdx+1);
                            name = userId.substring(tIdx+1);
                            break;
                    }
                }

                let channel = parseInt(channelSeqArray[i]);
                if(isNaN(channel)){
                    continue;
                }
                list[channel] = userIdSeqList[channel] = userId;

                channelUserMap.set(userId, {
                    type, name, videoState, vip, vad, screenshare
                });
            }
            // mixingLayoutInfo.channelSeqList = channelSeqArray;
            mixingLayoutInfo.userIdSeqList = userIdSeqList;
            mixingLayoutInfo.channelSeqList = list;
            mixingLayoutInfo.channelUserMap = channelUserMap;
        }finally{
            if(mixingLayoutInfo.secondStream){
                mixingLayoutInfo.secondStream.secondary = true;
                this._setMixingLayoutInfoChannelSeqList(mixingLayoutInfo.secondStream);
            }

            if(mixingLayoutInfo.roomGroupInMain){
                this._setMixingLayoutInfoChannelSeqList(mixingLayoutInfo.roomGroupInMain);
            }

            if(mixingLayoutInfo.roomGroupDatas){
                mixingLayoutInfo.roomGroupDataMap = {};
                mixingLayoutInfo.roomGroupDatas.forEach(data => {
                    if(!data) return;
                    // data bug
                    if(data.roomGroupData){
                        data = data.roomGroupData;
                    }
                    this._setMixingLayoutInfoChannelSeqList(data);
                    mixingLayoutInfo.roomGroupDataMap[data.roomGroupId] = data;
                });
            }
        }
    }

    async startScreenShare(stream, callback) {
        const mixer = this.#mixer;
        const audioTrack = stream.getAudioTracks()[0];
        const videoTrack = stream.getVideoTracks()[0];

        const jobs = [];
        const transceivers = mixer.conn.getPeerConnection().getTransceivers();
        if(transceivers.length <= 2){
            mixer.conn.addStream(stream);
        }else{
            const localStream = await RoomCall.Stream.getCurrentLocalStream();
            
            let mid = this.getMidObj({screenShare: true});

            if(audioTrack){
                jobs.push( mixer.conn.replaceTrackByMid(mid.screen.audio, audioTrack) );
            }
            if(videoTrack){
                if(localStream && localStream.getVideoTracks()[0]){
                    /* 임시
                    카나리아 94 버전에서 화면공유 여러번 할 경우 mixing 모드에서만 전송되지 않음.
                    다른 track 설정 후 시도하면 됨.
                     */
                    jobs.push(
                        mixer.conn.replaceTrackByMid(
                            mid.screen.video, localStream.getVideoTracks()[0]
                        ).then(() => {
                            mixer.conn.replaceTrackByMid(mid.screen.video, videoTrack)
                        })
                    );
                }else{
                    jobs.push( mixer.conn.replaceTrackByMid(mid.screen.video, videoTrack) );
                }
            }

            if(localStream){
                jobs.push( mixer.conn.replaceTrackByMid(mid.camera.audio,
                    localStream.getAudioTracks()[0]) );
                jobs.push( mixer.conn.replaceTrackByMid(mid.camera.video,
                    localStream.getVideoTracks()[0]) );
            }
        }

        await Promise.all(jobs);
        callback(stream);
    }

    stopScreenShare() {
        let roomData = Room.getRoomData();
        roomData.me.screenStatus = false;

        this.stopScreenShareRemoveStream();
    }

    stopScreenShareRemoveStream() {
        let stream = RoomCall.Stream.getCurrentScreenStream();
        if (!stream) {
            return false;
        }

        RoomCall.Stream.removeScreenStream();
        stream.getTracks().forEach((track)=> {
            try {
                track.stop();
            } catch (e) {
                console.warn('screenStream stop error', e);
            }
        });

        const mixer = this.#mixer;
        if (mixer && mixer.conn && !mixer.conn.isUnifiedPlan()) {
            mixer.conn.removeStream(stream);
        }

        let transceivers = mixer.conn.getPeerConnection().getTransceivers();
        [2,3].forEach(n => {
            if(!transceivers[n]) return;
            transceivers[n].direction = 'recvonly';
        })

        return true;
    }

    roomCallStopScreenShare() {
        roomCallService.stopScreenShare();
    }

    async changeMixingPage({page}) {
        await roomCallMixingService.changeMixingPage({page});
    }

    conectionStats({start}) {
        if(start && this._conectionStats_start){
            return;
        }
        this._conectionStats_start = start;

        let mixer = this.getMixer();
        if(!mixer || !mixer.conn){
            if(start){
                Room.addEventListener('room_call_mixerConnected', e => {
                    if(!this._conectionStats_start) return;
                    this.conectionStats({start: true});
                }, {once: true});
            }
            return;
        }

        Room.emit('startMixerConnectionStats');

        if(mixer.connectionStatsResult && mixer.connectionStatsResult.stop){
            mixer.connectionStatsResult.stop();
        }

        if(!start){
            return;
        }

        mixer.conn.getPeerConnection().getCsStats({
            peerId: mixer.userId,
            resultCallback: (result) => {
                mixer.connectionStatsResult = result;

                if(mixer.conn.isClosed()){
                    result.stop();
                    return;
                }

                // Room.emit('mixerConnectionStats', {mixer, result});
                Room.emit('userConnectionStats', {roomUser: mixer, result});

                let roomData = Room.getRoomData();
                let me = roomData.me;
                RoomCallLog.sendPeerStatsLog({
                    roomId: roomData.room.roomId,
                    userId: me.userId,
                    username: me.nickname,
                    remoteUserId: mixer.userId,
                    remoteUsername: 'mixer',
                    ipAddr: (me.userSession && me.userSession.ipAddr) || '',
                    connectionType: result.connectionType,
                    video: result.video,
                    audio: result.audio,
                    codecs: result.codecs,
                    intervalMs: result.intervalMs,
                    current: mixer.conn.current,
                    networkState: mixer.resolutionState || mixer.networkStatusLevel,
                    connTime: Date.now() - mixer.conn.getPeerConnection()._connectedTime,
                    mixerBridge: mixer.isBridgeMixer && me.mixerBridge
                });
            },
            stopCallback: (code, cause) => {
                console.debug("CsStats stoped", code, cause);

                this._conectionStats_start = false;
                Room.emit('stopMixerConnectionStats');
            }
        });
    }
    
    getMidObj({screenShare}){
        let mid = {
            camera: {
                audio: '0',
                video: '1',
            },
            screen: {
                audio: '2',
                video: '3',
            },
        }
        
        if(screenShare == undefined){
            let roomData = Room.getRoomData();
            const {screenStatus} = roomData.me;
            screenShare = screenStatus;
        }
        if(RoomCall.isWebinarLive()){
            if(screenShare){
                mid = {
                    camera: {
                        audio: '0',
                        video: '1',
                    },
                    screen: {
                        audio: '2',
                        video: '3',
                    },
                }
            }else{
                mid = {
                    camera: {
                        audio: '2',
                        video: '3',
                    },
                }
            }
        }
        
        return mid;
    }

    async addByPassSingleVideo ({targetUserId}) {
        if(Room.User.isMe(targetUserId)){
            return;
        }
        await roomCallMixingService.addByPassSingleVideo({targetUserId})
    }
    async removeByPassSingleVideo () {
        await roomCallMixingService.removeByPassSingleVideo()
    }
    async togglePassSingleVideo ({targetUserId=null}) {
        if(this.isSingleVideoMode()){
            await this.removeByPassSingleVideo();
        }else{
            await this.addByPassSingleVideo({targetUserId});
        }
    }
    isSingleVideoMode () {
        return Room.getRoomData().roomCall.mixingLayoutInfo?.layoutMode === 'singlevideomode';
    }

    async changeWallModeTargetScreen(data) {
        await roomCallMixingService.changeWallModeTargetScreen(data)
    }

    _CoreEvents = (() => {
        const EVENTS = {
            room_core_call_infoLoaded: async function() {
                const {callType} = Room.getRoomData().roomCall;
                if(callType !== CALL_TYPE){
                    return;
                }
                // await roomCallService.enterRoomCall();
                await RoomCall._enterCall(true);
            },
            room_core_call_changeVideoLayout: async function(e) {
                const layoutType = e.data?.layoutType;
                const isRoomGroup = (e.data?.roomGroupId && e.data?.roomGroupId !=='default');
                const isAutoLayout = layoutType === 'auto' && !isRoomGroup;
                if(!layoutType) return;
                if(!isAutoLayout && !layoutType.startsWith('ml_') && !isRoomGroup){
                    return;
                }

                if(this.isMixing()){
                    if(isAutoLayout && !Room.Call.isWebinar()){
                        await RoomCall.changeCallType({
                            callType: 'p2p',
                            layoutType
                        })
                    }else{
                        await this.changeMixingLayoutType(e.data);
                    }
                }else{
                    await RoomCall.changeCallType({
                        callType: CALL_TYPE,
                        layoutType
                    })
                }
            },
            room_core_call_changeUserStream: async function (e) {
                const roomUser = this.#mixer;
                if (!roomUser) return;

                const conn = roomUser.conn;
                if (!conn) return;

                const {stream, deviceType} = e.data;
                const audioTrack = stream.getAudioTracks()[0];
                const videoTrack = stream.getVideoTracks()[0];

                let mid = this.getMidObj({});

                switch (deviceType) {
                    case 'audioinput':
                    case 'audio':
                        await conn.replaceTrackByMid(mid.camera.audio, audioTrack)
                        break;
                    case 'video':
                    case 'videoinput':
                        await conn.replaceTrackByMid(mid.camera.video, videoTrack)
                        break;
                }
            },
            room_core_call_startScreenShare: async function (e) {
                const {screenStream, callback} = e.data;
                await this.startScreenShare(screenStream, callback);
            },
            room_core_call_stopScreenShare: function(e) {
                this.stopScreenShare()
                Room.emit('room_call_screenShare', e.data);
            }
        }

        for(let eventType in EVENTS){
            const func = EVENTS[eventType];
            EVENTS[eventType] = function(e){
                if(
                    // roomCall.callType !== this.getCallType()
                    !this.isMixing(true)
                    && e.data?.ignoreCallType !== true
                ){
                    return;
                }
                return func.apply(this, arguments);
            }
        }
        return EVENTS;
    })()

}

function _Events(){
    return {
        room_reconnected: function(e){
            const mixer = this.getMixer();
            if(mixer?.conn?.isConnected()){
                return;
            }
            RoomCall._enterCall();
        },
        room_call_changeCallType: async function(e) {
            const mixer = this.getMixer();
            // if(e.data.beforeCallType === CALL_TYPE){
            if(e.data.beforeCallType === this.getCallType()){
                this.destroy();
                return;
            }

            // TODO callType 변경 이후 client 에서 enter call 을 하도록 바뀌면서 서버 타이밍과 안맞게 된다. 임시 딜레이
            setTimeout(() => {
                RoomCall._enterCall();
            }, 500);
        },
        room_call_offer: async function(e){
            // let roomData = Room.getRoomData();
            let mixer = this.getMixer();
            let mixerId = e.userId;
            const mixerParams = e.data;
            let {
                sdp,
                videoWidth,
                videoHeight,
                bitRate,
                streamIdMap,
                reqTrackIds,
                supportedVideoCodecs,
                firstPeerConnection,
                sdpPlan,
                secondVideo
            } = e.data;

            console.log('#[grm-call] recv offer : clazz[%s], mixerId[%s], videoSize[%sx%s], bitrate[%s], firstPeerConnection[%s]\r\n',
                this.getClassName(),
                mixerId, ''+videoWidth, ''+videoHeight, ''+bitRate, ''+firstPeerConnection, sdp);

            if(firstPeerConnection){
                Room.emit('room_call_startMixerConnection');
                if(mixer && mixer.conn){
                    mixer.conn.close();
                    mixer.conn = null;
                }
            }

            // // mixing 모드에서 ice failed 로 재접속 될 경우 해상도가 -1x-1 로 오는 버그로 인한 임시 코드
            // if(!RoomCall.ifSfu() && videoWidth < 0 && videoHeight < 0){
            //     videoWidth = 320;
            //     videoHeight = 180;
            //     if(bitRate < 96)
            //         bitRate = 96;
            // }

            if(!mixer || !mixer.conn){
                mixer = mixer || {};
                this.setMixer(mixer);

                Object.assign(mixer, {
                    userId: mixerId,
                    username: 'mixer',
                    nickname: 'mixer',
                });
                mixer.conn = this.createMixerWebRTCConnection.call(this, mixer, {
                    sdpSemantics: sdpPlan && sdpPlan.includes('unified') ? 'unified-plan' : ''
                });
            }

            mixer.setting = {
                streamIdMap,
                reqTrackIds,
                videoWidth,
                videoHeight,
                bitRate,
                supportedVideoCodecs,
            };

            // 임시
            let stream = await RoomCall.Stream.getCurrentLocalStream();

            await (async () => {
                let config = {
                    video: {
                        width: videoWidth,
                        height: videoHeight,
                        frameRate: 10
                    }
                };

                if(RoomCall.isWebinarLive() && !RoomUser.isSpeakerRole()) {
                    RoomCallStream.removeCurrentLocalStream();
                    RoomCallStream.removeCurrentPreviewStream();
                    stream = null;
                    return;
                }

                if(videoWidth < 0 && videoHeight < 0){
                    config.video = false;
                    if(stream){
                        await GrmWebRTC.stopMediaStreamVideoTracks(stream);
                    }
                }

                if(!stream || stream.getAudioTracks().length === 0){
                    config.audio = {};
                }

                try{
                    Room.trigger('room_call_loadLocalStreamStart');
                    let streamObj = await RoomCall.Stream.createLocalStream(config);
                    stream = streamObj.stream;
                    Room.trigger('room_call_loadLocalStream', {stream: streamObj.previewStream || streamObj.stream});
                }catch(e){
                    console.error('#[grm-call] create localstream error', config, e);
                }
            })();

            // localstream
            await (async () => {
                if(!stream) return;
                const audioTrack = stream.getAudioTracks()[0];
                const videoTrack = stream.getVideoTracks()[0];

                // mixer.conn.addStream(stream);
                const transceivers = mixer.conn.getPeerConnection().getTransceivers();
                if(transceivers.length === 0){
                    mixer.conn.addStream(stream);
                    return;
                }
                if(!RoomCall.isWebinarLive()){
                    if(audioTrack){
                        await mixer.conn.replaceTrackByMid('0', audioTrack);
                    }
                    if(videoTrack){
                        await mixer.conn.replaceTrackByMid('1', videoTrack);
                    }                    
                } else{
                    const {roomUserRole} = RoomUser.getMe();
                    let mid = this.getMidObj({});

                    if(mid.camera.audio !== '0'){
                        await mixer.conn.replaceTrackByMid('0', null);
                    }
                    if(mid.camera.audio !== '1'){
                        await mixer.conn.replaceTrackByMid('1', null);
                    }
                    await mixer.conn.replaceTrackByMid(mid.camera.audio, roomUserRole['mic'] ? audioTrack : null);
                    await mixer.conn.replaceTrackByMid(mid.camera.video, roomUserRole['camera'] ? videoTrack : null);
                }
            })();

            let localSdp = await mixer.conn.createAnswer(sdp);
            localSdp = await mixer.conn.setLocalDescription(localSdp);

            // set bandwidth
            (() => {
                if(!bitRate) return;
                if(!mixer.conn.getPeerConnection().getSenders){
                    return;
                }
                if(!mixer.conn.getPeerConnection().getSenders().find(s => {
                    return s.track && s.track.kind === 'video'
                })){
                    return;
                }

                const transceivers = mixer.conn.getPeerConnection().getTransceivers();
                const videoSender = transceivers[1].sender;

                if(mixerParams.secondVideo?.bitRate <= 0 && mixerParams.secondVideo?.videoWidth > 0){
                    mixerParams.secondVideo.bitRate = 256;
                }
                if(mixerParams.secondVideo && mixerParams.secondVideo?.bitRate > 0){
                    const screenStream = Room.getRoomData().me.screenStatus && RoomCall.Stream.getCurrentScreenStream();
                    if(screenStream){
                        let screenTrans = transceivers.find(t => t.sender?.track?.id === screenStream.getVideoTracks()[0].id);

                        if(screenTrans){
                            mixer.conn.changeSenderRTCRtpEncodingParameters(screenTrans.sender, {bitrate: mixerParams.bitRate});
                        }
                        if(videoSender && videoSender !== screenTrans?.sender){
                            mixer.conn.changeSenderRTCRtpEncodingParameters(videoSender, {bitrate: mixerParams.secondVideo.bitRate});
                        }
                    }
                }else if(videoSender){
                    mixer.conn.changeSenderRTCRtpEncodingParameters(videoSender, {bitrate: mixerParams.bitRate});
                }
            })();

            // send answer
            {
                let data = {
                    callType: 'mixing',
                    toUserId: mixerId,
                    sdp: localSdp,
                }

                let map = await RoomCall.Stream.getCurrentStreamIdsData({
                    conn: mixer.conn
                });
                map.unifiedMids = {
                    audio: map.streamParams.audioTrackMid,
                    video: map.streamParams.videoTrackMid,
                    secondAudio: map.streamParams.screenAudioTrackMid,
                    secondVideo: map.streamParams.screenVideoTrackMid,
                };

                let screen = RoomCall.Stream.getCurrentScreenStream();
                if (screen) {
                    map.bypassStreamId = screen.id;
                }

                if (map) {
                    data.streamIdMap = map;
                }

                await roomCallService.sendAnswer(data);
            }
        },
        room_call_answer: function(e){
            console.log('@@', e.type);
        },
        room_call_icecandidate: function(e){
            let mixer = this.getMixer();
            if(!mixer || !mixer.conn){
                return;
            }

            (() => {
                let cd = e.data.icecandidate.candidate;
                let stIdx = cd && cd.indexOf('tcp ');
                if(!stIdx || stIdx < 0){
                    return;
                }
                let edIdx = cd.indexOf('typ', stIdx);
                let arr = cd.substring(stIdx, edIdx).split(' ');
                console.log('telnet %s %s', arr[2], arr[3]);
            })();

            mixer.conn.addIceCandidate(e.data.icecandidate);
        },
        room_call_icecandidateComplete: function(e){

        },
        room_call_signalStable: function(e){

        },
        room_call_mixerClosed: function(e){

        },
        room_call_changeMixingLayout: function(e){
            if(e.data && (e.data.success === false || e.data.success === 'false')){
                return;
            }
            const roomData = Room.getRoomData();
            roomData.roomCall.videoLayout = e.data.layoutType;
            try{
                let str = JSON.stringify(e.data);
                if(roomData.roomCall.mixingLayoutInfoOriData === str){
                    return;
                }
                roomData.roomCall.mixingLayoutInfoOriData = str;
            }catch(e){
                console.error(e);
            }
            try{
                // TODO
                // if (e.data.layoutType === 'ml_01_00') {
                //     return;
                // }
                this._setMixingLayoutInfoChannelSeqList(e.data);
                roomData.roomCall.mixingLayoutInfo = e.data;

                // if(!this.room.group.groupSetting.useMixingVideoPage){
                //     delete this.room.info.mixingLayoutInfo.pageInfo;
                // }
                Room.emit('room_call_changeMixingLayout', _.cloneDeep(e.data));
            }catch(e){
                console.error('mixingLayout error 3', e);
            }
        },
        room_call_screenShare: function (e) {
            let { userIds, screenShare, streamId } = e.data;

            // if (!userIds?.length && !screenShare) {
            //     return;
            // }

            // userIds = screenShare ? [e.userId] : userIds;
            userIds = [e.userId];
            userIds.forEach(userId => {
                const roomUser = Room.User.getRoomUser(userId);

                if (!roomUser){
                    console.error('Not Found RoomUser => room_call_screenShare', `userId = ${userId}`);
                    return;
                }

                // roomUser.screenshare = screenShare;
                if (screenShare){
                    roomUser.screenStreamId = streamId;
                    if (!Room.User.isMe(roomUser)) {
                        RoomCall.Mixer.stopScreenShare();
                    }
                } else {
                    if (Room.User.isMe(userId)) {
                        RoomCall.Mixer.stopScreenShare();
                    } else {
                        const roomData = Room.getRoomData();
                        if (roomData.me.screenStatus){
                            RoomCall.Mixer.stopScreenShareRemoveStream();
                        }
                    }
                }
            });

            Room.emit('room_call_screenShare', { userIds, screenShare: screenShare });
        },
        room_call_changeWebinarType: function (e) {
            // 해당 event 없을 경우, room.call.api.js의 event가 덮어 씌워져서 중복 실행됨
        },
        room_call_changeVideoQuality: function (e) {
            // 해당 event 없을 경우, room.call.api.js의 event가 덮어 씌워져서 중복 실행됨
        },
        room_changeUserRoleId: function (e) {            
            if(RoomCall.isWebinarLive()){
                const {roomUserRole} = RoomUser.getMe();
                if(roomUserRole.roleId !== Role.SPEAKER){
                    RoomCallStream.removeCurrentLocalStream();
                    RoomCallStream.removeCurrentPreviewStream();
                }
            }
        },
        room_call_changeHideRoomGroupUserInFilmArea: function(e) {
            const roomCall = Room.getRoomData().roomCall;
            const hideRoomGroupUserInFilmArea = e.data.hideRoomGroupUserInFilmArea
            roomCall.hideRoomGroupUserInFilmArea = hideRoomGroupUserInFilmArea

            Room.emit(e)
        }
    };
}



export const RoomCallMixer = new RoomCallMixerApi();